module.exports = __webpack_public_path__ + "img/athens-logo.380be0e7.jpg";